import { supabase } from './supabaseClient.js';
import { TABLES } from './constants.js';

// ============================================================
// المصادقة بالكامل عبر Supabase Auth — لا توجد كلمات مرور
// مخزَّنة في جداول التطبيق إطلاقاً (تختلف جذريًا عن نسخة Claude
// التي كانت تخزّن SHA-256 يدويًا في جدول staff — تم إلغاء ذلك).
// ============================================================

/** دخول الموظفين (مدير / فورمان / فني) بالبريد وكلمة المرور */
export async function signInStaff(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return getCurrentProfile();
}

/** تسجيل خروج أي مستخدم (موظف أو مستأجر) */
export async function signOut() {
  await supabase.auth.signOut();
}

/** يجلب صف profiles للمستخدم الحالي (يحدّد دوره: admin/foreman/technician/tenant) */
export async function getCurrentProfile() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data, error } = await supabase.from(TABLES.PROFILES).select('*').eq('id', user.id).single();
  if (error) { console.error(error); return null; }
  return data;
}

/** يستمع لتغيّر حالة الجلسة (دخول/خروج/تجديد توكن) ليحدّث الواجهة تلقائيًا */
export function onAuthChange(callback) {
  return supabase.auth.onAuthStateChange((_event, session) => callback(session));
}

// ------------------------------------------------------------
// مسار المستأجر: إنشاء حساب Supabase Auth حقيقي ثم "استرداد"
// رمز التفعيل لربط الحساب بالشقة. هذا يحتاج دالة RPC آمنة
// (SECURITY DEFINER) في قاعدة بياناتك لم أُنشئها أو أُطبّقها —
// راجع migration/OPTIONAL_redeem_activation_code.sql
// وأكّد لي أولاً قبل تشغيلها، كما طلبت بالضبط.
// ------------------------------------------------------------

/** تسجيل مستأجر جديد بالبريد وكلمة مرور يختارها */
export async function tenantSignUp(email, password) {
  const emailRedirectTo = new URL(import.meta.env.BASE_URL || '/', window.location.origin).toString();
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { emailRedirectTo }
  });
  if (error) throw error;
  return data;
}

/** بعد تسجيل الدخول، يربط حساب المستأجر برمز التفعيل الذي أعطاه المدير */
export async function redeemActivationCode(code) {
  // يعتمد على دالة RPC مقترحة (غير مُطبَّقة تلقائيًا) — انظر الملف المذكور أعلاه
  const { data, error } = await supabase.rpc('redeem_activation_code', { p_code: code });
  if (error) throw error;
  return data; // متوقَّع: صف الشقة بعد الربط
}
